<template>
  <div class="contentText">
    <v-form ref="form" v-model="valid" lazy-validation>
      <v-row>
        <v-col cols="12" lg="6" md="12" sm="12">
          <v-text-field v-model="name" :counter="50" :rules="textFieldRules" :label="nameLabelComputed"
            :prepend-inner-icon="nameSvgComputed" class="inputStyle" required outlined />
        </v-col>
        <v-col cols="12" lg="6" md="12" sm="6">
          <v-text-field v-model="contact_name" :rules="textFieldRules" :label="contact_nameLabelComputed"
            class="inputStyle" :prepend-inner-icon="contact_nameSvgComputed" outlined />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" lg="6" md="12" sm="6">
          <v-text-field v-model="email" :rules="emailRules" :label="emailLabelComputed"
            :prepend-inner-icon="emailSvgComputed" class="inputStyle" required outlined />
        </v-col>
        <v-col cols="12" lg="6" md="12" sm="6">
          <VuePhoneNumberInput v-model="phone" v-on:update="updatePhone" v-bind:translations="myTranslation" required />
        </v-col>
      </v-row>
      <v-row>
        <v-col lg="12">
          <v-textarea class="inputStyle mt-2" :label="textLabelComputed" :rules="textAreaRules" outlined rows="6"
            v-model="text" :prepend-inner-icon="textSvgComputed" />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="10" lg="9">
          <v-checkbox v-model="privacyAccepted" :rules="[v => !!v || 'Обязательное поле']" hide-details="auto"
            class="mt-0 pt-0" color="cyan darken-4">
            <template #label>
              <span style="font-size: 14px;">
                {{ $t('message.privacyConsentPrefix') }}<a href="/file/acceptance_policy_farminn.docx" target="_blank"
                  rel="noopener noreferrer" style="color: #007070; text-decoration: underline;" @click.stop>{{
                    $t('message.privacyConsentLink') }}</a>
              </span>
            </template>
          </v-checkbox>
          <div class="mt-3 mb-4" style="font-size: 12px; color: rgba(0,0,0,0.6); line-height: 1.2;">
            {{ $t('message.privacyPolicyPrefix') }}<a href="/file/privacy_policy_farminn.docx" target="_blank"
              rel="noopener noreferrer" style="color: #007070; text-decoration: underline;" @click.stop>{{
                $t('message.privacyPolicyLink') }}</a>{{ $t('message.privacyPolicyAnd') }}<a
              href="/file/cookie_policy_farminn.docx" target="_blank" rel="noopener noreferrer"
              style="color: #007070; text-decoration: underline;" @click.stop>{{
                $t('message.cookiePolicyLink') }}</a>
          </div>
        </v-col>
      </v-row>
      <div v-if="isAuth">
        <v-btn v-if="this.changeData" @click="pushChangeContent">Изменить</v-btn>
      </div>
      <v-row v-if="changeData">
        <v-col cols="12" lg="6" md="7" sm="6">
          <v-btn outlined v-on:click="send()" x-large color="teal darken-4">{{
            $t('message.partnershipForSuppliersForm12')
            }}</v-btn>
          <v-dialog v-model="dialog" width="300">
            <v-card>
              <v-card-text class="pt-6 pb-8 circle-check">
                <i class="material-icons mr-5 mt-3 ml-2">check_circle</i>
                <p>{{ $t('message.partnershipForSuppliersForm13') }}</p>
              </v-card-text>
            </v-card>
          </v-dialog>
          <AlertLoading :loading="dialog_loading" />
        </v-col>
      </v-row>
    </v-form>
  </div>
</template>

<script>
import VuePhoneNumberInput from 'vue-phone-number-input'
import AlertLoading from './AlertLoading.vue'
export default {
  name: 'ReportForm',
  components: { VuePhoneNumberInput, AlertLoading },
  props: [
    'nameLabel',
    'contact_nameLabel',
    'emailLabel',
    'textLabel',

    'nameSvg',
    'contact_nameSvg',
    'emailSvg',
    'textSvg',

    'id_nameLabel',
    'id_contact_nameLabel',
    'id_emailLabel',
    'id_textLabel',
    'id_nameSvg',
    'id_contact_nameSvg',
    'id_emailSvg',
    'id_textSvg',
    'change'
  ],
  methods: {
    updatePhone: function (value) { console.log(value) },
    send: async function () {
      await this.$refs.form.validate()
      if (this.valid) {
        this.$store.dispatch('mail/SEND_REPORTFORM', {
          'name': this.name,
          'contact_name': this.contact_name,
          'email': this.email,
          'phone': this.phone,
          'text': this.text
        })
      }
    },
    getT18nData(i18n_data, id_content) {
      if (i18n_data == '') {
        return { 'value_rus': i18n_data, 'value_eng': i18n_data, 'id_content': id_content }
      }
      let ru_value = Object.entries(this.$i18n.messages['ru']['message']).filter(value => value[1] == i18n_data)
      if (ru_value.length != 0) {
        return {
          'value_rus': this.$i18n.messages['ru']['message'][ru_value[0][0]],
          'value_eng': this.$i18n.messages['en-US']['message'][ru_value[0][0]],
          'id_content': id_content
        }
      }
      let eng_value = Object.entries(this.$i18n.messages['en-US']['message']).filter(value => value[1] == i18n_data)
      if (eng_value.length != 0) {
        return {
          'value_rus': this.$i18n.messages['ru']['message'][eng_value[0][0]],
          'value_eng': this.$i18n.messages['en-US']['message'][eng_value[0][0]],
          'id_content': id_content
        }
      }
      return { 'value_rus': i18n_data, 'value_eng': i18n_data, 'id_content': id_content }
    },
    valueDict(value, id_content) {
      return {
        'value_rus': value,
        'value_eng': value,
        'id_content': id_content
      }
    },
    pushChangeContent() {
      let content_to_change = {
        'nameLabel': this.nameLabelData,
        'emailLabel': this.emailLabelData,
        'textLabel': this.textLabelData,
        'contact_nameLabel': this.contact_nameLabelData,

        'nameSvg': this.nameSvgData,
        'emailSvg': this.emailSvgData,
        'textSvg': this.textSvgData,
        'contact_nameSvg': this.contact_nameSvgData
      }
      this.$store.dispatch('contentChanges/SET_CONTENT_TO_CHANGE', {
        'type_to_change': 'ReportForm',
        'content_to_change': content_to_change
      })
      this.$router.push('/change_content')
    }
  },
  data() {
    let id_list = [this.id_nameLabel,
    this.id_emailLabel,
    this.id_textLabel,
    this.id_contact_nameLabel,
    this.id_nameSvg,
    this.id_textSvg,
    this.id_emailSvg,
    this.id_contact_nameSvg].filter(id => id !== undefined)
    let changeData = this.change !== undefined ? this.change : true
    let _nameLabel = this.getT18nData(this.nameLabel, this.id_nameLabel)
    let _emailLabel = this.getT18nData(this.emailLabel, this.id_emailLabel)
    let _textLabel = this.getT18nData(this.textLabel, this.id_textLabel)
    let _contact_nameLabel = this.getT18nData(this.contact_nameLabel, this.id_contact_nameLabel)
    let _nameSvg = this.valueDict(this.nameSvg, this.id_nameSvg)
    let _emailSvg = this.valueDict(this.emailSvg, this.id_emailSvg)
    let _textSvg = this.valueDict(this.textSvg, this.id_textSvg)
    let _contact_nameSvg = this.valueDict(this.contact_nameSvg, this.id_contact_nameSvg)
    let letThis = this
    new Promise(function (resolve, reject) {
      letThis.$store.dispatch('contentChanges/GET_CONTENT', { 'id_list': id_list })
        .then(() => {
          let content = letThis.$store.getters['contentChanges/content']
          for (let cont_item of content) {
            if (cont_item['id_content'] === parseInt(letThis.id_nameLabel)) {
              _nameLabel['value_rus'] = cont_item['value_rus']
              _nameLabel['value_eng'] = cont_item['value_eng']
            }
            if (cont_item['id_content'] === parseInt(letThis.id_emailLabel)) {
              _emailLabel['value_rus'] = cont_item['value_rus']
              _emailLabel['value_eng'] = cont_item['value_eng']
            }
            if (cont_item['id_content'] === parseInt(letThis.id_textLabel)) {
              _textLabel['value_rus'] = cont_item['value_rus']
              _textLabel['value_eng'] = cont_item['value_eng']
            }
            if (cont_item['id_content'] === parseInt(letThis.id_contact_nameLabel)) {
              _contact_nameLabel['value_rus'] = cont_item['value_rus']
              _contact_nameLabel['value_eng'] = cont_item['value_eng']
            }
            if (cont_item['id_content'] === parseInt(letThis.id_nameSvg)) {
              _nameSvg['value_rus'] = cont_item['value_rus']
              _nameSvg['value_eng'] = cont_item['value_eng']
            }
            if (cont_item['id_content'] === parseInt(letThis.id_emailSvg)) {
              _emailSvg['value_rus'] = cont_item['value_rus']
              _emailSvg['value_eng'] = cont_item['value_eng']
            }
            if (cont_item['id_content'] === parseInt(letThis.id_textSvg)) {
              _textSvg['value_rus'] = cont_item['value_rus']
              _textSvg['value_eng'] = cont_item['value_eng']
            }
            if (cont_item['id_content'] === parseInt(letThis.id_contact_nameSvg)) {
              _contact_nameSvg['value_rus'] = cont_item['value_rus']
              _contact_nameSvg['value_eng'] = cont_item['value_eng']
            }
          }
          letThis.checkContent = true
        })
    })
    return {
      privacyAccepted: false,
      checkContent: false,
      nameLabelData: _nameLabel,
      emailLabelData: _emailLabel,
      textLabelData: _textLabel,
      contact_nameLabelData: _contact_nameLabel,
      nameSvgData: _nameSvg,
      emailSvgData: _emailSvg,
      textSvgData: _textSvg,
      contact_nameSvgData: _contact_nameSvg,
      changeData: changeData,
      valid: false,
      name: '',
      contact_name: '',
      email: '',
      text: '',
      textFieldRules: [
        v => !!v || 'Обязательное поле',
        v => (v && v.length <= 50) || 'Поле должно содержать не более 50 символов'
      ],
      textAreaRules: [
        v => !!v || 'Обязательное поле',
        v => (v && v.length <= 200) || 'Поле должно содержать не более 200 символов'
      ],
      emailRules: [
        v => !!v || 'Обязательное поле',
        v => /.+@.+\.\w{2,4}/.test(v) || 'Электронная почта должна быть действительной'
      ],
      phone: '',
      phoneRules: [
        v => !!v || 'Обязательное поле',
        v => /.+@.+\..+/.test(v) || 'Телефон должен быть действительным'
      ]
    }
  },
  computed: {
    nameLabelComputed() {
      if (!this.changeData & this.$i18n.locale == 'ru') { this.nameLabelData['value_rus'] = this.nameLabel }
      if (!this.changeData & this.$i18n.locale == 'en-US') { this.nameLabelData['value_eng'] = this.nameLabel }
      if (this.$i18n.locale == 'ru') { return this.nameLabelData['value_rus'] }
      if (this.$i18n.locale == 'en-US') { return this.nameLabelData['value_eng'] }
    },
    emailLabelComputed() {
      if (!this.changeData & this.$i18n.locale == 'ru') { this.emailLabelData['value_rus'] = this.emailLabel }
      if (!this.changeData & this.$i18n.locale == 'en-US') { this.emailLabelData['value_eng'] = this.emailLabel }
      if (this.$i18n.locale == 'ru') { return this.emailLabelData['value_rus'] }
      if (this.$i18n.locale == 'en-US') { return this.emailLabelData['value_eng'] }
    },
    textLabelComputed() {
      if (!this.changeData & this.$i18n.locale == 'ru') { this.textLabelData['value_rus'] = this.textLabel }
      if (!this.changeData & this.$i18n.locale == 'en-US') { this.textLabelData['value_eng'] = this.textLabel }
      if (this.$i18n.locale == 'ru') { return this.textLabelData['value_rus'] }
      if (this.$i18n.locale == 'en-US') { return this.textLabelData['value_eng'] }
    },
    contact_nameLabelComputed() {
      if (!this.changeData & this.$i18n.locale == 'ru') { this.contact_nameLabelData['value_rus'] = this.contact_nameLabel }
      if (!this.changeData & this.$i18n.locale == 'en-US') { this.contact_nameLabelData['value_eng'] = this.contact_nameLabel }
      if (this.$i18n.locale == 'ru') { return this.contact_nameLabelData['value_rus'] }
      if (this.$i18n.locale == 'en-US') { return this.contact_nameLabelData['value_eng'] }
    },
    nameSvgComputed() {
      if (!this.changeData & this.$i18n.locale == 'ru') { this.nameSvgData['value_rus'] = this.nameSvg }
      if (!this.changeData & this.$i18n.locale == 'en-US') { this.nameSvgData['value_eng'] = this.nameSvg }
      if (this.$i18n.locale == 'ru') { return this.nameSvgData['value_rus'] }
      if (this.$i18n.locale == 'en-US') { return this.nameSvgData['value_eng'] }
    },
    emailSvgComputed() {
      if (!this.changeData & this.$i18n.locale == 'ru') { this.emailSvgData['value_rus'] = this.emailSvg }
      if (!this.changeData & this.$i18n.locale == 'en-US') { this.emailSvgData['value_eng'] = this.emailSvg }
      if (this.$i18n.locale == 'ru') { return this.emailSvgData['value_rus'] }
      if (this.$i18n.locale == 'en-US') { return this.emailSvgData['value_eng'] }
    },
    textSvgComputed() {
      if (!this.changeData & this.$i18n.locale == 'ru') { this.textSvgData['value_rus'] = this.textSvg }
      if (!this.changeData & this.$i18n.locale == 'en-US') { this.textSvgData['value_eng'] = this.textSvg }
      if (this.$i18n.locale == 'ru') { return this.textSvgData['value_rus'] }
      if (this.$i18n.locale == 'en-US') { return this.textSvgData['value_eng'] }
    },
    contact_nameSvgComputed() {
      if (!this.changeData & this.$i18n.locale == 'ru') { this.contact_nameSvgData['value_rus'] = this.contact_nameSvg }
      if (!this.changeData & this.$i18n.locale == 'en-US') { this.contact_nameSvgData['value_eng'] = this.contact_nameSvg }
      if (this.$i18n.locale == 'ru') { return this.contact_nameSvgData['value_rus'] }
      if (this.$i18n.locale == 'en-US') { return this.contact_nameSvgData['value_eng'] }
    },
    isAuth() {
      return this.$store.getters['adminAuth/checkAuth']
    },
    myTranslation() {
      return {
        countrySelectorLabel: this.$t('message.partnershipForSuppliersForm6'),
        countrySelectorError: this.$t('message.partnershipForSuppliersForm6Error'),
        phoneNumberLabel: this.$t('message.partnershipForSuppliersForm7'),
        example: this.$t('message.partnershipForSuppliersForm7Example')
      }
    },
    dialog: {
      get() { return this.$store.state['mail']['reportformLoad'] },
      set(value) {
        if (this.$store.getters['mail/status'] === 'ok') {
          this.$refs.form.reset()
          this.$store.dispatch('mail/SET_READY', 'reportform')
        }
        this.$store.dispatch('mail/HIDE_FORM', 'reportformLoad')
      }
    },
    dialog_loading: {
      get() {
        return this.$store.getters['mail/reportformLoading']
      }
    }
  }
}
</script>

<style scoped></style>
